import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { isClientUser } from '../_helpers/can-use/current-user-roles';

/**
 * A client user sees a booking through its timeline only. Sends them from /tutorreports/:id to /timeline/:id,
 * so every link that leads a client to the tutor reports page lands on the timeline instead. Everyone else
 * goes through. The API applies the same rule to what it returns.
 */
export const clientTimelineGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  if (!isClientUser()) {
    return true;
  }
  return inject(Router).createUrlTree(['/timeline', route.paramMap.get('id')]);
};
